import React from 'react';
import PropTypes from 'prop-types';

function ViewPublishSite({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinejoin="round"
        d="M10.674 14.972c.664.58 1.173 1.188 1.454 1.552-.28.363-.79.972-1.454 1.552-.925.806-2.062 1.479-3.245 1.479-1.184 0-2.32-.673-3.246-1.48a11.159 11.159 0 01-1.454-1.551c.28-.364.79-.973 1.454-1.552.925-.806 2.062-1.48 3.246-1.48 1.183 0 2.32.674 3.245 1.48z"
      />
      <path d="M8.588 16.524a1.16 1.16 0 11-2.319 0 1.16 1.16 0 012.32 0z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.905 20.952a9 9 0 000-18m0 18c2.485 0 4.5-4.029 4.5-9 0-4.97-2.015-9-4.5-9m0 18c-.459 0-.91-.034-1.35-.1m1.35.1c-.384 0-.757-.096-1.113-.277m1.113-17.723a9 9 0 00-8.982 9.573m8.982-9.573c-2.486 0-4.5 4.05-4.5 8.55m12.6 3.735h-5.85m6.5-5.4h-17.3"
      />
    </svg>
  );
}

ViewPublishSite.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ViewPublishSite;
